export const FUNCTIONAL_HAMBURGER_HTML_ID = "hamburger-nav";
export const FUNCTIONAL_HAMBURGER_PADDING = 24;
export const FUNCTION_HAMBURGER_SIZE = 24;
